/* Filtri collezione: bottone FILTRI che apre/chiude la sidebar verticale.
   Lo stato scelto viene ricordato tra le pagine (localStorage). */
(function () {
  var bottone = document.querySelector('[data-bdr-filtri]');
  var colonne = document.querySelector('.facets-vertical');
  if (!bottone || !colonne) return;

  var CHIAVE = 'bdr-filtri-aperti';

  function imposta(aperti) {
    colonne.classList.toggle('bdr-filtri-chiusi', !aperti);
    bottone.setAttribute('aria-expanded', aperti ? 'true' : 'false');
    try {
      localStorage.setItem(CHIAVE, aperti ? '1' : '0');
    } catch (e) {
      /* navigazione privata: pazienza, niente memoria */
    }
  }

  bottone.addEventListener('click', function () {
    imposta(colonne.classList.contains('bdr-filtri-chiusi'));
  });

  /* Stato iniziale: CHIUSI di default; si aprono solo se l'utente
     li aveva lasciati aperti (scelta ricordata). Niente animazione al load. */
  var salvato = null;
  try {
    salvato = localStorage.getItem(CHIAVE);
  } catch (e) {}
  if (salvato !== '1') {
    colonne.classList.add('bdr-filtri-anima-off');
    imposta(false);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        colonne.classList.remove('bdr-filtri-anima-off');
      });
    });
  }
})();
